import { useCookies } from "@vueuse/integrations/useCookies";
import { defaultCookieOptions } from "./default-cookie-options";

/**
 * Set the contents of the `campaign_id` cookie
 * from data passed in by the `campaign` URL parameter.
 */
export function setCampaignCookieFromParams() {
  const cookies = useCookies(["campaign_id"]);
  const params = parseParams(document.location.href.split("?")[1] || "");

  if (params["campaign"]) {
    cookies.set(
      "campaign_id",
      <string>params["campaign"],
      defaultCookieOptions
    );
  }
}

/**
 * Add click event listeners to elements with the class `iframe-blocker`
 * that open a URL in a new tab when clicked.
 */
export function attachIframeBlockerHandlers() {
  const iframeBlockers = document.getElementsByClassName("iframe-blocker");

  for (const blocker of iframeBlockers) {
    blocker.addEventListener("click", () => {
      const url = blocker.getAttribute("data-url");

      if (url) {
        const windowProxy = window.open(url, "_blank");
        windowProxy?.focus();
      }
    });
  }
}

/**
 * Update anchor tags within elements with the class `container`
 * to open in a new tab if they link to an external site.
 */
export function setExternalLinksToNewTab() {
  document.querySelectorAll(".container a").forEach((element) => {
    const href = element.getAttribute("href");

    if (href && /^https?:/.test(href) && href.indexOf(location.origin) === -1) {
      element.setAttribute("target", "__new");
    }
  });
}

/**
 * Parses a query string into an object with key-value pairs.
 *
 * Example:
 * - Input: "name=John&age=30&hobbies[]=reading&hobbies[]=coding"
 * - Output: { name: "John", age: "30", hobbies: ["reading", "coding"] }
 *
 * @param query - The query string.
 * @returns the key-value pairs.
 */
export function parseParams(query: string): Record<string, string | string[]> {
  const regex = /([^&=]+)=?([^&]*)/g;

  const params: Record<string, string | string[]> = {};
  let e;

  const decode = (str: string) => decodeURIComponent(str.replace(/\+/g, " "));

  while ((e = regex.exec(query))) {
    let k = decode(e[1]);
    const v = decode(e[2]);

    if (k.substring(k.length - 2) === "[]") {
      k = k.substring(0, k.length - 2);
      params[k] = params[k] ?? [];
      (<string[]>params[k]).push(v);
    } else {
      params[k] = v;
    }
  }

  return params;
}
